'use client'

import { Stack } from '@mui/material'

import AssistantMarkdown from '~/features/assistant/AssistantMarkdown'

import ThinkingShimmer from '../parts/ThinkingShimmer'
import ProposalStepRow from './ProposalStepRow'
import ThoughtRow from './ThoughtRow'
import ToolRunRow from './ToolRunRow'
import type { TurnStep } from './turnModel'

type TurnStepsProps = {
  steps: TurnStep[]
  /** The reply is still streaming. */
  streaming: boolean
  /** The key of the step the turn is working on, if any. */
  liveStepKey?: string
}

/** The steps of a turn in order, each at the same depth. */
export default function TurnSteps({ steps, streaming, liveStepKey }: TurnStepsProps) {
  return (
    <Stack spacing={1} data-testid="assistant-worked-steps">
      {steps.map((step) => (
        <StepRow key={step.key} step={step} live={step.key === liveStepKey} streaming={streaming} />
      ))}
    </Stack>
  )
}

type StepRowProps = {
  step: TurnStep
  live: boolean
  streaming: boolean
}

function StepRow({ step, live, streaming }: StepRowProps) {
  switch (step.kind) {
    case 'narration':
      return <AssistantMarkdown>{step.part.text.trim()}</AssistantMarkdown>
    case 'toolRun':
      return <ToolRunRow run={step} live={live} interrupted={!streaming} />
    case 'proposal':
      return <ProposalStepRow part={step.part} />
    case 'thought':
      return live && step.streaming ? <ThinkingShimmer /> : <ThoughtRow text={step.text} />
  }
}
